import { ValidationStatusState, } from '@kubit/web-ui-components/validationStatus/types';
import { FONT_WEIGHT } from '../../../foundations/typography';
import { commonStyles } from '../commonStyles';
import { ValidationStatusVariants } from '../variants';
export const getDefaultStyles = (FOUNDATIONS, FONT) => ({
    [ValidationStatusVariants.DEFAULT]: {
        ...commonStyles(FOUNDATIONS),
        [ValidationStatusState.DEFAULT]: {
            icon: {
                color: FOUNDATIONS.color_neutral_icon_50,
                width: FOUNDATIONS.size_300,
                height: FOUNDATIONS.size_300,
            },
            explainText: {
                color: FOUNDATIONS.color_neutral_font_50,
                font_variant: FOUNDATIONS.font_size_paragraph_small,
                font_weight: FONT_WEIGHT.font_regular,
            },
        },
        [ValidationStatusState.SUCCESS]: {
            icon: {
                color: FOUNDATIONS.color_feedback_success_icon_50,
                width: FOUNDATIONS.size_300,
                height: FOUNDATIONS.size_300,
            },
            explainText: {
                color: FOUNDATIONS.color_neutral_font_50,
                font_variant: FOUNDATIONS.font_size_paragraph_small,
                font_weight: FONT_WEIGHT.font_regular,
            },
        },
        [ValidationStatusState.ERROR]: {
            icon: {
                color: FOUNDATIONS.color_feedback_error_icon_50,
                width: FOUNDATIONS.size_300,
                height: FOUNDATIONS.size_300,
            },
            explainText: {
                color: FOUNDATIONS.color_feedback_error_font_50,
                font_variant: FOUNDATIONS.font_size_paragraph_small,
                font_weight: FONT_WEIGHT.font_regular,
            },
        },
    },
});
//# sourceMappingURL=default.js.map